<div [@routerTransition] class="login-page">
  <div class="row justify-content-md-center">
    <div class="col-md-4">
      <div class="clearfix"></div>
      <h1 style="text-shadow: 1px 1px 1px #000;">Inventory Management System</h1>
      <div class="clearfix"></div>
      <form (keyup.enter)="onLoggedin()" role="form">
        <div class="clearfix"></div>
        <div class="clearfix"></div>

        <div *ngIf="error_message != ''" [innerHTML]="error_message" class="alert alert-danger"></div>
        <div class="form-content">
          <div class="form-group">
            <input [(ngModel)]="user" class="form-control input-underline input-lg" id="" name="user"
                   placeholder="{{ 'User name' | translate }}" style="text-shadow: 1px 1px 1px #000;" type="text">
          </div>

          <div class="form-group">
            <input [(ngModel)]="pass" class="form-control input-underline input-lg" id="" name="password"
                   placeholder="{{ 'Password' | translate }}" style="text-shadow: 1px 1px 1px #000;" type="password">
          </div>
        </div>
        <button (click)="onLoggedin()" class="btn rounded-btn">{{ 'Log in' | translate }}</button> &nbsp;
      </form>
    </div>
  </div>
</div>
